import server from 'utils/request';
import sendUrl from 'src/main';

/**
 * 身份证号码获取用户手机号码
 */
export function getMobileByIdentNo(data) {
  return server({
    baseURL: sendUrl,
    url: '/e_send/party/getMobileByIdentNo',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 登录接口
 */
export function loginSend(data) {
  return server({
    baseURL: sendUrl,
    url: '/e_send/party/loginBySms',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 函件送达查询接口
 */
export function queryMail(data) {
  return server({
    baseURL: sendUrl,
    url: '/e_send/party/query/mail',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

/**
 * 短信送达查询接口
 */
export function queryMessage(data) {
  return server({
    baseURL: sendUrl,
    url: '/e_send/party/query/sms',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

/**
 * 函件详情接口
 */
export function detailMail(data) {
  return server({
    baseURL: sendUrl,
    url: '/e_send/party/mail/details',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 函件下载接口
 */
export function download(params) {
  return server({
    baseURL: sendUrl,
    url: '/e_send/party/mail/download',
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
    responseType: 'blob',
    params
  })
}

/**
 * 函件批量下载接口
 */
export function batchDownload(params) {
  return server({
    baseURL: sendUrl,
    url: '/e_send/party/mail/download/batch',
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
    responseType: 'blob',
    params
  })
}
/**
 * 送达num查询接口
 */
export function count(data) {
  return server({
    baseURL: sendUrl,
    url: '/e_send/party/number/count',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}


// WEBPACK FOOTER //
// ./src/api/delivery/delivery.js